import React from 'react';
import classes from './BlackCardWithIcon.module.scss'

interface Props {
    iconName: string;
    title?: string;
    text: string;
}

const BlackCardWithIcon = ({iconName, text, title}: Props) => {
    return (
        <div className={classes.block}>
            <img className={classes.icon} alt={'icon'} src={require(`../../media/icons/${iconName}.svg`)}/>
            <div className={classes.text}>
                {title && <h5>{title}</h5>}
                <span>{text}</span>
            </div>
        </div>
    );
};

export default BlackCardWithIcon;